import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiButton } from '@taiga-ui/core';
import { TuiPager } from '@taiga-ui/kit';
import { map } from 'rxjs';
import { ExaminationsNavigationService } from '../../services/examination-navigation.service';

@Component({
  selector: 'pxc-examinations-navigation',
  imports: [TuiButton, CommonModule, TuiPager],
  host: {
    class: 'flex min-h-18 max-w-full items-center gap-1 px-[var(--examination-inset,1rem)]',
  },
  templateUrl: './examinations-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationsNavigationComponent {
  readonly maxDots = 10;

  readonly examinationNavigationService = inject(ExaminationsNavigationService);

  readonly canGoToPrevious$ = this.examinationNavigationService.canGoToPrevious$;
  readonly canGoToNext$ = this.examinationNavigationService.canGoToNext$;
  readonly index$ = this.examinationNavigationService.index$;
  readonly length$ = this.examinationNavigationService.examinations$.pipe(map((examinations) => examinations.length));
}
